import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-placeholder-glow',
    templateUrl: './placeholder-glow.component.html',
    styleUrl: './placeholder-glow.component.scss',
    standalone: false
})
export class PlaceholderGlowComponent {
	@Input() enableButton = true
	@Input() enableHeader = true
	@Input() loop = 5

	get places(): { col: number }[] {
		const places: { col: number }[] = []
		const cols = [7, 4, 4, 5, 6]

		for (let i = 0; i < this.loop; i++) {
			if (i > cols.length - 1) places.push({ col: 8 })
			else places.push({ col: cols[i] })
		}

		return places
	}
}
